import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common";
import { ScrollText } from "lucide-react";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/logs").then(({ data }) => setLogs(data)); }, []);
  return (
    <div data-testid="admin-logs">
      <PageHeader title="Audit Logs" subtitle="System activity trail" />
      {logs.length === 0 ? <EmptyState icon={ScrollText} title="No logs yet" /> : (
        <div className="bg-white border border-border rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-muted-foreground"><tr><th className="p-4">User</th><th className="p-4">Action</th><th className="p-4">Module</th><th className="p-4">IP</th><th className="p-4">Time</th></tr></thead>
            <tbody>{logs.map((l) => (
              <tr key={l.id} className="border-t border-border" data-testid={`log-${l.id}`}>
                <td className="p-4 font-medium text-navy">{l.user_name}</td><td className="p-4 font-mono text-xs">{l.action}</td><td className="p-4">{l.module}</td><td className="p-4 text-muted-foreground">{l.ip || "-"}</td><td className="p-4 text-muted-foreground text-xs">{new Date(l.created_at).toLocaleString()}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
